<template>
  <div class="modal-overlay">
    <div class="modal-container">
      <!-- Cabeçalho -->
      <div class="modal-header">
        <h6>Editar Despesa</h6>
        <i class="bi bi-x-circle close-icon" @click="cancel"></i>
      </div>
      <div class="spacer"></div>

      <!-- Conteúdo -->
      <div class="modal-content">
        <!-- Exibe tipo -->
        <h5 class="section-title">
          <span v-if="registro.tipo === 'Entradas da Loja'" class="text-success">
            Entradas da Loja
          </span>
          <span v-else>
            {{ registro.tipo }}
          </span>
        </h5>

        <!-- Linha: Descrição + Vencimento -->
        <div class="row mb-3">
          <div class="col-md-8">
            <div class="form-group">
              <label>Descrição:</label>
              <input type="text" :value="registro.descricao" class="form-control" disabled />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>Vencimento:</label>
              <input type="date" v-model="formData.dataVencimento" class="form-control" />
            </div>
          </div>
        </div>

        <h5 class="section-title">Editar Dados</h5>

        <div class="row mb-3">

          <!-- Data de Pagamento -->
          <div class="col-md-2">
            <div class="form-group">
              <label for="data_pagamento">Data de Pagamento:</label>
              <input
                type="date"
                id="data_pagamento"
                v-model="formData.dataPagamento"
                :disabled="isAInformar(formData.formaPagamentoId)"
                class="form-control"
              />
            </div>
          </div>

          <!-- Valor Principal -->
          <div class="col-md-2">
            <div class="form-group">
              <label for="valor">Valor principal:</label>
              <input
                type="text"
                v-model.lazy="valorFormatted"
                @focus="handleFocusValor"
                @blur="handleBlurValor"
                class="form-control"
              />
            </div>
          </div>

          <!-- Juros -->
          <div v-if="mostrarJurosEMulta" class="col-md-2">
            <div class="form-group">
              <label for="juros">Juros:</label>
              <input
                type="text"
                v-model.lazy="jurosFormatted"
                @focus="handleFocusJuros"
                @blur="handleBlurJuros"
                class="form-control"
              />
            </div>
          </div>

          <!-- Multa -->
          <div v-if="mostrarJurosEMulta" class="col-md-2">
            <div class="form-group">
              <label for="multa">Multa:</label>
              <input
                type="text"
                v-model.lazy="multaFormatted"
                @focus="handleFocusMulta"
                @blur="handleBlurMulta"
                class="form-control"
              />
            </div>
          </div>

          <!-- Desconto -->
          <div class="col-md-2">
            <div class="form-group">
              <label for="desconto">Desconto:</label>
              <input
                type="text"
                v-model.lazy="descontoFormatted"
                @focus="handleFocusDesconto"
                @blur="handleBlurDesconto"
                class="form-control"
              />
            </div>
          </div>

          <!-- Total Pago -->
          <div class="col-md-2">
            <div class="form-group">
              <label>Total pago:</label>
              <input
                type="text"
                :value="totalPagoFormatted"
                class="form-control"
                disabled
              />
            </div>
          </div>

          <!-- Forma de Pagamento -->
          <div class="col-md-4">
            <div class="form-group">
              <label for="forma_pagamento">Forma de Pagamento:</label>
              <select
                id="forma_pagamento"
                v-model="formData.formaPagamentoId"
                class="form-control"
              >
                <option value="">Selecione</option>
                <option v-for="f in formas" :key="f.id" :value="f.id">
                  {{ f.nome }}
                </option>
              </select>
            </div>
          </div>

          <!-- Campos Cheque Condicionais -->
          <div v-if="isCheque(formData.formaPagamentoId)" class="col-md-2">
            <div class="form-group">
              <label for="banco_numero">Banco nº:</label>
              <input
                type="text"
                id="banco_numero"
                v-model="formData.bancoNumero"
                class="form-control"
                required
              />
            </div>
          </div>

          <div v-if="isCheque(formData.formaPagamentoId)" class="col-md-2">
            <div class="form-group">
              <label for="agencia">Agência:</label>
              <input
                type="text"
                id="agencia"
                v-model="formData.agencia"
                class="form-control"
                required
              />
            </div>
          </div>

          <div v-if="isCheque(formData.formaPagamentoId)" class="col-md-2">
            <div class="form-group">
              <label for="cheque_numero">Cheque nº:</label>
              <input
                type="text"
                id="cheque_numero"
                v-model="formData.chequeNumero"
                class="form-control"
                required
              />
            </div>
          </div>

          <!-- Conta Financeira -->
          <div class="col-md-4">
            <div class="form-group">
              <label>Conta Financeira</label>

              <template v-if="isAInformar(formData.formaPagamentoId)">
                <input type="text" class="form-control" value="A informar" disabled />
              </template>

              <template v-else>
                <select v-model="formData.contaFinanceiraId" class="form-control" required>
                  <option value="">Selecione</option>
                  <option v-for="c in contasFinanceiras" :key="c.id" :value="c.id">
                    {{ c.texto }}
                  </option>
                </select>
              </template>
            </div>
          </div>
        </div>

        <!-- Callout de propagação -->
        <div class="row mb-3" v-if="podePropagar">
          <div class="col-12">
            <div class="propagar-alert">
              <div class="propagar-left">
                <i class="bi bi-exclamation-circle-fill propagar-icon" aria-hidden="true"></i>
                <input
                  id="ck-propagar"
                  class="form-check-input propagar-check"
                  type="checkbox"
                  v-model="propagarProximas"
                />
                <label class="form-check-label propagar-headline" for="ck-propagar">
                  As parcelas futuras do mesmo lançamento, ainda “A informar”, receberão este valor e este dia no vencimento.
                </label>
              </div>
            </div>
          </div>
        </div>

        <!-- Observações -->
        <div class="form-group mb-3">
          <label for="observacoes">Observações:</label>
          <textarea
            id="observacoes"
            v-model="formData.observacoes"
            class="form-control"
            rows="3"
          ></textarea>
        </div>

        <!-- Ações -->
        <div class="d-flex justify-content-end mt-4 mb-4">
          <button class="btn btn-secondary me-2" @click="cancel">Cancelar</button>
          <button class="btn btn-primary" :disabled="!formValid" @click="save">Salvar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive, computed, onMounted, watch } from 'vue';
import axios from '@/services/axios';
import Holidays from 'date-holidays';

export default {
  name: 'EditarDespesas',
  props: {
    id: { type: Number, required: true },
    origem: { type: String, required: true } // 'entradas' | 'despesas'
  },
  setup(props, { emit }) {
    const registro = reactive({
      tipo: '',
      valor: 0,
      juros: 0,
      multa: 0,
      desconto: 0,
      valor_total_pago: 0,
      dataVencimento: '',
      descricao: ''
    });

    const formas = ref([]);
    const contasFinanceiras = ref([]);

    const formData = reactive({
      formaPagamentoId: '',
      dataVencimento: '',
      dataPagamento: '',
      dataRecebimento: '',
      contaFinanceiraId: null,
      observacoes: '',
      bancoNumero: '',
      agencia: '',
      chequeNumero: '',
      juros: 0,
      multa: 0,
      desconto: 0
    });

    // checkbox
    const propagarProximas = ref(false);
    const podePropagar = computed(() => props.origem === 'despesas');

    // feriados
    const hd = new Holidays('BR', 'DF');

    // =========================
    // Helpers (moeda BR)
    // =========================
    function parseBRMoney(v) {
      const s = String(v ?? '');
      const n = parseFloat(s.replace(/\./g, '').replace(',', '.'));
      return isNaN(n) ? 0 : n;
    }

    function formatBRMoney(n) {
      const num = Number(n || 0);
      return num.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    // =========================
    // Estado de edição
    // =========================
    const editingValor = ref('');
    const editingJuros = ref('');
    const editingMulta = ref('');
    const editingDesconto = ref('');

    // =========================
    // Computeds formatados
    // =========================
    const valorFormatted = computed({
      get() {
        if (editingValor.value === null || editingValor.value === undefined) return '';
        const num = parseBRMoney(editingValor.value);
        return formatBRMoney(num);
      },
      set(val) {
        editingValor.value = val ?? '';
      }
    });

    const descontoFormatted = computed({
      get() {
        if (editingDesconto.value === null || editingDesconto.value === undefined) return '';
        const num = parseBRMoney(editingDesconto.value);
        return formatBRMoney(num);
      },
      set(val) {
        editingDesconto.value = val ?? '';
      }
    });

    const jurosFormatted = computed({
      get() {
        if (editingJuros.value === null || editingJuros.value === undefined) return '';
        const num = parseBRMoney(editingJuros.value);
        return formatBRMoney(num);
      },
      set(val) {
        editingJuros.value = val ?? '';
      }
    });

    const multaFormatted = computed({
      get() {
        if (editingMulta.value === null || editingMulta.value === undefined) return '';
        const num = parseBRMoney(editingMulta.value);
        return formatBRMoney(num);
      },
      set(val) {
        editingMulta.value = val ?? '';
      }
    });

    const totalPagoFormatted = computed(() => {
      const total =
        parseBRMoney(editingValor.value) +
        parseBRMoney(editingJuros.value) +
        parseBRMoney(editingMulta.value) -
        parseBRMoney(editingDesconto.value);

      return formatBRMoney(Math.max(0, total));
    });

    const mostrarJurosEMulta = computed(() => {
      const venc = String(formData.dataVencimento || '').trim();
      const pag = String(formData.dataPagamento || '').trim();
      if (!venc || !pag) return false;
      return pag > venc;
    });

    // =========================
    // Regras de foco/blur
    // =========================
    const handleFocusValor = () => {
      if (editingValor.value != null) editingValor.value = String(editingValor.value).replace(/\./g, '');
    };

    const handleBlurValor = () => {
      const num = parseBRMoney(editingValor.value);
      editingValor.value = formatBRMoney(num);
    };

    const handleFocusJuros = () => {
      if (editingJuros.value != null) editingJuros.value = String(editingJuros.value).replace(/\./g, '');
    };

    const handleBlurJuros = () => {
      const num = parseBRMoney(editingJuros.value);
      editingJuros.value = formatBRMoney(num);
    };

    const handleFocusMulta = () => {
      if (editingMulta.value != null) editingMulta.value = String(editingMulta.value).replace(/\./g, '');
    };

    const handleBlurMulta = () => {
      const num = parseBRMoney(editingMulta.value);
      editingMulta.value = formatBRMoney(num);
    };

    const handleFocusDesconto = () => {
      if (editingDesconto.value != null) editingDesconto.value = String(editingDesconto.value).replace(/\./g, '');
    };

    const handleBlurDesconto = () => {
      const num = parseBRMoney(editingDesconto.value);
      editingDesconto.value = formatBRMoney(num);
    };

    // =========================
    // Loaders
    // =========================
    const loadData = async () => {
      try {
        const res = await axios.get(`/financeiro/despesas-completas/${props.id}`, {
          params: { origem: props.origem }
        });
        const data = res.data.data;

        registro.tipo = data.tipo;
        registro.descricao = data.descricao;
        registro.valor = Number(data.valor || 0);
        registro.juros = Number(data.juros || 0);
        registro.multa = Number(data.multa || 0);
        registro.desconto = Number(data.desconto || 0);
        registro.valor_total_pago = Number(
          data.valor_total_pago ??
          (Number(data.valor || 0) + Number(data.juros || 0) + Number(data.multa || 0) - Number(data.desconto || 0))
        );

        registro.dataVencimento = (data.data_vencimento ?? '').split('T')[0] || '';
        formData.dataVencimento = registro.dataVencimento;

        formData.juros = registro.juros;
        formData.multa = registro.multa;
        formData.desconto = registro.desconto;

        editingValor.value = formatBRMoney(registro.valor);
        editingJuros.value = formatBRMoney(registro.juros);
        editingMulta.value = formatBRMoney(registro.multa);
        editingDesconto.value = formatBRMoney(registro.desconto);

        Object.assign(formData, {
          formaPagamentoId: data.forma_pagamento_id,
          dataPagamento: data.data_pagamento?.split('T')[0] || '',
          dataRecebimento: data.data_recebimento?.split('T')[0] || '',
          contaFinanceiraId: data.conta_financeira_id ?? null,
          observacoes: data.observacoes,
          bancoNumero: data.banco_numero,
          agencia: data.agencia,
          chequeNumero: data.cheque_numero
        });
      } catch (err) {
        console.error('❌ erro em loadData():', err);
      }
    };

    const loadFormas = async () => {
      try {
        const { data } = await axios.get('/cadastros/formas-pagamento');

        const norm = (s) =>
          (s ?? '')
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .trim()
            .toLowerCase();

        const lista = (data?.data ?? data) ?? [];

        formas.value = lista
          .filter((fp) => norm(fp.nome) !== 'brinde')
          .sort((a, b) => (a.nome ?? '').localeCompare((b.nome ?? ''), 'pt-BR', { sensitivity: 'base' }));
      } catch (e) {
        console.error('Erro ao carregar formas de pagamento:', e);
        formas.value = [];
      }
    };

    const loadContas = async () => {
      const res = await axios.get('/financeiro/contas-financeiras');
      contasFinanceiras.value = (res.data.data || []).map((c) => ({
        id: c.id,
        texto: `${c.apelido} | Ag ${c.agencia} | CC ${c.numero_conta}`
      }));
    };

    // =========================
    // Regras forma pagamento
    // =========================
    const isCheque = (id) => {
      const f = formas.value.find((f) => f.id === id);
      return f ? f.nome.toLowerCase() === 'cheque' : false;
    };

    const isAInformar = (id) => {
      const f = formas.value.find((f) => f.id === id);
      return f ? f.nome.toLowerCase() === 'a informar' : false;
    };

    const idEspecie = computed(() => formas.value.find((f) => f.nome.toLowerCase() === 'espécie')?.id || null);
    const isEspecie = (id) => id === idEspecie.value;

    const nextBusinessDay = (d0) => {
      const d = new Date(d0);
      while ([0, 6].includes(d.getDay()) || hd.isHoliday(d, 'public')) d.setDate(d.getDate() + 1);
      return d;
    };

    const calcularDataRecebimento = (v, fid) => {
      if (!v || !fid) return '';
      const f = formas.value.find((f) => f.id === fid);
      const name = (f?.nome || '').toLowerCase();

      const days = name.includes('crédito') ? 31 : name.includes('débito') ? 1 : (f?.prazo_pagamento || 0);
      const d = new Date(v + 'T00:00:00');
      d.setDate(d.getDate() + days);

      return nextBusinessDay(d).toISOString().split('T')[0];
    };

    // validação
    const formValid = computed(() => {
      const fp = formData.formaPagamentoId;
      if (!fp) return false;
      if (!isAInformar(fp) && !formData.dataPagamento) return false;
      if (!isAInformar(fp) && (formData.contaFinanceiraId == null || formData.contaFinanceiraId === '')) return false;
      if (isCheque(fp) && !(formData.bancoNumero && formData.agencia && formData.chequeNumero)) return false;
      return true;
    });

    const isEntradaLoja = computed(() => registro.tipo === 'Entradas da Loja');

    // watcher para data recebimento e regra "A informar"
    watch(
      () => [formData.dataPagamento, formData.formaPagamentoId],
      ([dp, fid]) => {
        const nome = (formas.value.find((f) => f.id === fid)?.nome || '').toLowerCase();

        if (nome === 'a informar') {
          formData.contaFinanceiraId = null;
          formData.dataPagamento = '';
          formData.dataRecebimento = '';
          return;
        }

        if (dp && fid) formData.dataRecebimento = calcularDataRecebimento(dp, fid);
        else formData.dataRecebimento = '';
      }
    );

    // =========================
    // SAVE: envia valor BRUTO + desconto
    // =========================
    const save = async () => {
      const fp = formData.formaPagamentoId;

    const valorPrincipal = parseBRMoney(editingValor.value);
    const jurosNum = parseBRMoney(editingJuros.value);
    const multaNum = parseBRMoney(editingMulta.value);
    const descontoNum = parseBRMoney(editingDesconto.value);

    const payload = {
      forma_pagamento_id: fp,
      conta_financeira_id: isAInformar(fp) ? null : (formData.contaFinanceiraId || null),

      valor: valorPrincipal,
      juros: jurosNum,
      multa: multaNum,
      desconto: descontoNum,

      data_vencimento: formData.dataVencimento || null,
      data_pagamento: formData.dataPagamento || null,
      data_recebimento: isEntradaLoja.value ? undefined : (formData.dataRecebimento || null),

      observacoes: formData.observacoes,
      banco_numero: formData.bancoNumero,
      agencia: formData.agencia,
      cheque_numero: formData.chequeNumero
    };

      const params = { origem: props.origem };
      if (podePropagar.value && propagarProximas.value) params.propagar = 1;

      try {
        const res = await axios.put(`/financeiro/despesas-completas/${props.id}`, payload, { params });
        console.log('Propagações:', res.data?.propagated, res.data?.propagated_due);
        emit('updated');
      } catch (e) {
        console.error(e);
        alert('Falha ao salvar. Verifique os campos e tente novamente.');
      }
    };

    const cancel = () => emit('cancel');

    onMounted(async () => {
      await loadFormas();
      await loadContas();
      await loadData();
    });

    return {
      registro,
      formas,
      contasFinanceiras,
      formData,

      isCheque,
      isAInformar,
      isEspecie,
      formValid,
      isEntradaLoja,

      // valor e desconto
      editingValor,
      valorFormatted,
      handleFocusValor,
      handleBlurValor,

      editingDesconto,
      descontoFormatted,
      handleFocusDesconto,
      handleBlurDesconto,

      jurosFormatted,
      multaFormatted,
      totalPagoFormatted,
      mostrarJurosEMulta,
      handleFocusJuros,
      handleBlurJuros,
      handleFocusMulta,
      handleBlurMulta,

      // propagação
      propagarProximas,
      podePropagar,

      save,
      cancel
    };
  }
};
</script>

<style scoped>
.modal-header {
  background: #ccc;
  padding: 10px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.5);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-container {
  background: #fff;
  width: 100%;
  max-width: 60%;
  overflow-y: auto;
  margin: 0 10px;
  border-radius: 0;
}
.modal-content { padding: 15px; }
.close-icon { font-size: 1.5rem; cursor: pointer; }
.spacer { margin-bottom: 20px; }
.section-title { font-size: 0.9rem; font-weight: bold; margin-bottom: 10px; }
.form-group label { font-weight: bold; margin-bottom: 5px; display: block; }
.form-control { width: 100%; padding: 5px; border: 1px solid #ced4da; border-radius: 0; }

/* Callout */
.propagar-alert {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f9f2ea;
  border: 1px solid #c9a77a;
  border-radius: 4px;
  padding: 8px 10px;
  gap: 12px;
  width: 100%;
}
.propagar-left {
  margin-top: 0 !important;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
}
.propagar-icon {
  color: #8B5E34;
  font-size: 0.80rem;
  line-height: 1;
}
.propagar-check {
  transform: translateY(-1px) scale(0.85);
  transform-origin: left center;
  vertical-align: middle;
  accent-color: #8B5E34;
  border-color: #8B5E34;
}
.propagar-headline {
  font-size: 0.7rem;
  color: #6b4e2e;
  font-weight: 600;
  margin: 0;
  white-space: nowrap;
}
</style>
